// src/actions/hazardAction.js
import {HAZARD_CLEAR, HAZARD_SET} from '../reducers/hazardReducer';

export const setHazard = ({ title, body, data }) => ({
  type: HAZARD_SET,
  payload: { title, body, data }
});

export const clearHazard = () => ({ type: HAZARD_CLEAR });
